import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';

const SummaryCards = ({
  amountPaid,
  amountPending,
  amountExpired,
  amountPaidF,
  amountPendingF,
  amountExpiredF,
  filtrado,
  filters
}) => {
  const formatCurrency = (value) => {
    if (!value) return value;
    return parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const hasActiveFilters = filtrado && (filters?.descricao || filters?.nome || filters?.dataInicio || filters?.dataFim || filters?.telefone || filters?.status);
  const paid = hasActiveFilters ? amountPaidF : amountPaid;
  const pending = hasActiveFilters ? amountPendingF : amountPending;
  const expired = hasActiveFilters ? amountExpiredF : amountExpired;

  const CardComponent = ({ backgroundColor, title, amount, subtitle, fontSize = { xs: 15, md: 20 } }) => (
    <Grid item xs={12} sm={4} md={4}>
      <Paper
        elevation={3}
        sx={{
          backgroundColor,
          border: '1px solid lightgray',
          borderRadius: 2,
          marginTop: 1,
          padding: 2,
          width: { xs: '90%', sm: '75%', md: '66%', lg: '66%' },
          margin: 'auto',
        }}
      >
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography color="white" fontSize={{ xs: 20, md: 25 }} fontWeight="bold" fontFamily="Ubuntu" variant="h6" align="center">
            {title}
          </Typography>
        </Grid>
        {subtitle && (
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography color="white" fontSize={{ xs: 11, md: 12 }} fontFamily="Ubuntu" align="center" sx={{ opacity: 0.9 }}>
              {subtitle}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography color="white" fontSize={fontSize} fontWeight="bold" fontFamily="Ubuntu" variant="h6" align="center">
            {formatCurrency(amount)}
          </Typography>
        </Grid>
      </Paper>
    </Grid>
  );

  return (
    <Grid container spacing={2}>
      <CardComponent
        backgroundColor="#4CAF50"
        title="Recebido"
        amount={paid}
        subtitle={hasActiveFilters ? 'Com filtro aplicado' : null}
      />
      <CardComponent
        backgroundColor="#FF9800"
        title="Pendente"
        amount={pending}
        subtitle={hasActiveFilters ? 'Com filtro aplicado' : null}
      />
      <CardComponent
        backgroundColor="#F44336"
        title="Expirado"
        amount={expired}
        subtitle={hasActiveFilters ? 'Com filtro aplicado' : null}
      />
    </Grid>
  );
};

export default SummaryCards;
